import { render, staticRenderFns } from "./NoticeMilitaryFamily.vue?vue&type=template&id=dddf71bc&scoped=true"
import script from "./NoticeMilitaryFamily.vue?vue&type=script&lang=js"
export * from "./NoticeMilitaryFamily.vue?vue&type=script&lang=js"
import style0 from "./NoticeMilitaryFamily.vue?vue&type=style&index=0&id=dddf71bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddf71bc",
  null
  
)

export default component.exports